import React from 'react';
import styles from './ProductsTable.module.css';

type CategoryColor = 'blue' | 'green' | 'teal' | 'purple' | 'orange';

interface Product {
  rank: number;
  name: string;
  category: string;
  categoryColor: CategoryColor;
  unitsSold: number;
  performance: number;
}

interface ProductsTableProps {
  products: Product[];
}

export const ProductsTable: React.FC<ProductsTableProps> = ({ products }) => {
  return (
    <div className={styles.container}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.thProduct}>Product</th>
            <th className={styles.thCategory}>Category</th>
            <th className={styles.thUnits}>Units Sold</th>
            <th className={styles.thPerformance}>Performance</th>
          </tr>
        </thead>
        <tbody>
          {products.map((product) => (
            <tr key={product.rank} className={styles.row}>
              <td className={styles.tdProduct}>
                <span className={styles.rank}>{product.rank}</span>
                <span className={styles.productName}>{product.name}</span>
              </td>
              <td className={styles.tdCategory}>
                <span className={`${styles.categoryBadge} ${styles[product.categoryColor]}`}>
                  {product.category}
                </span>
              </td>
              <td className={styles.tdUnits}>{product.unitsSold}</td>
              <td className={styles.tdPerformance}>
                <div className={styles.performanceWrapper}>
                  <div className={styles.performanceBar}>
                    <div
                      className={styles.performanceFill}
                      style={{ width: `${product.performance}%` }}
                    />
                  </div>
                  <span className={styles.performanceValue}>{product.performance}%</span>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
